import './style.scss'

const Pinned = ({ text }: { text?: string }) => {
  return (
    <div className="Pinned">
      <img src="/images/icon-pinned.svg" alt="Pinned" />
      <p>{text}</p>
    </div>
  )
}

export default Pinned
